const links_to_graph_data = links => {
  const link_to_edge = link => {
    const edge = {
      data: {
        id: link.recordLinkId,
        source: link['leftRecord']['internalRecordId'],
        target: link['rightRecord']['internalRecordId'],
        label: link.state,
        state: link.state
      }
    };
    return edge;
  };

  const nodes = [];
  const nodeIds = {};

  const node_from_record = record => {
    const nodeData = {
      data: {
        id: record.internalRecordId,
        label: record.recordId,
        rid: record.internalRecordId
      }
    };
    return nodeData;
  };

  const link_to_node = (link, nodes, nodeIds) => {
    // console.log("Adding recordId " + link["leftRecord"]["internalRecordId"]);
    const left = link['leftRecord'];
    if (!nodeIds[left.internalRecordId]) {
      nodeIds[left.internalRecordId] = true;
      nodes.push(node_from_record(left));
    }
    const right = link['rightRecord'];
    if (!nodeIds[right.internalRecordId]) {
      nodeIds[right.internalRecordId] = true;
      nodes.push(node_from_record(link['rightRecord']));
    }
  };

  links.forEach(link => link_to_node(link, nodes, nodeIds));
  const edges = links.map(link => link_to_edge(link));
  return {
    nodes: nodes,
    edges: edges
  };
};

export default links_to_graph_data;
